/* @flow @format */

import { combineEpics } from 'redux-observable';

import activities from './activities';
import fetchData from './fetchData';
import retry from './retry';
import signin from './signin';
import syncConfig from './syncConfig';
import syncProgress from './syncProgress';

export default combineEpics(signin, fetchData, syncConfig, syncProgress, retry, activities);
